import { ColumnModel } from "../../../../../api/api.models"
import { LocalizationHelper } from "../../../../../../helpers"
import { Enums } from "../../../../../../models/common"
import { UserSessionService } from "../../../../../../services/user-session"
import { GridService } from "../../../../../../services/grid"
import { MeasureCollection } from "../../../../../../models/custom"
import { DataProviderRequest } from "../../../../../../data-provider"

//#region Public Types

export const VALVE_MANAGE_SERVICE_NAME = 'valveManageService'
export const VALVE_MANAGE_SERVICE_PROVIDER_NAME = 'valveManageServiceProvider'

//#endregion

export class ValveManageService {


    // #region Ctor

    constructor(private userSessionService: UserSessionService, private gridService: GridService) { }

    // #endregion

    // #region Public Methods

    public getHistoryGridColumns(): ColumnModel {

        const serialNbr: ColumnModel = new ColumnModel()

        serialNbr.idName = 'serialNbr'
        serialNbr.name = 'serialNbr'
        serialNbr.caption = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.SerialNbr)
        serialNbr.type = Enums.DataTypeClass.Integer

        serialNbr.width = 100

        return serialNbr
    }

    public getStatusGridColumns(): ColumnModel[] {
        const serialNbr: ColumnModel = new ColumnModel()
        serialNbr.name = 'serialNbr'
        serialNbr.idName = 'serialNbr'
        serialNbr.type = Enums.DataTypeClass.Integer
        serialNbr.caption = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.SerialNbr)

        const valveState: ColumnModel = new ColumnModel()
        valveState.name = 'valveState'
        valveState.idName = 'valveState'
        valveState.type = Enums.DataTypeClass.Text
        valveState.caption = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ValveState)

        const data: ColumnModel = new ColumnModel()
        data.name = 'data'
        data.idName = 'data'
        data.type = Enums.DataTypeClass.Datetime
        data.caption = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Date)

        return [serialNbr, valveState, data]
    }

    public getValveState(serialNbrs: number[]): DataProviderRequest<MeasureCollection[]> {
        return this.userSessionService.getDataProvider().Measurements.getLatestMeasurementsFilter([], serialNbrs, [], [Enums.DataType.VALDRIVER_STATE, Enums.DataType.VALDRIVER_STATE])

    }

    public getSourceObjects(gridObject, referenceType) {
        return this.gridService.getSourceObjectFromGridObject(gridObject, referenceType)

    }

    // #endregion
}
